<template>
  <NuxtLayout>
    <NuxtPage/>
  </NuxtLayout>
</template>
<script lang="ts" setup>
  useHead({
    title: "海南康迪电动汽车",
    link: [{ rel: 'icon', type: 'image/x-icon', href: 'favicon.ico' }],
    meta: [
      { name: 'keywords', content: '海南康迪电动汽车，康迪首页' },
      { name: 'description', content: '康迪电动汽车(海南)有限公司' }
    ]
  })

</script>
<style lang="scss">
</style>